import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

const BUSINESS_TIME_ZONE = 'America/New_York';

export const SnoozePreset = {
    tomorrowMorning: 'tomorrow_morning',
    plus24Hours: 'plus_24_hours',
    custom: 'custom',
};

/** UTC instant for a snooze preset. Custom values are local datetimes. */
export const snoozeAvailableAt = (preset, customValue, now = dayjs()) => {
    if (preset === SnoozePreset.plus24Hours) {
        return now.add(24, 'hour').toISOString();
    }
    if (preset === SnoozePreset.tomorrowMorning) {
        return now
            .tz(BUSINESS_TIME_ZONE)
            .add(1, 'day')
            .hour(9)
            .minute(0)
            .second(0)
            .millisecond(0)
            .toISOString();
    }
    if (!customValue) {
        return null;
    }
    const parsed = dayjs(customValue);
    return parsed.isValid() ? parsed.toISOString() : null;
};
